import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "gfu-grid__cell gfu-1of3",
        "data-qa": `filtersbox-field:${_ctx.displayName}`
      }, [
        _createVNode(_component_option_field, _mergeProps({..._ctx.fieldAttrs, ..._ctx.$props}, {
          "model-value": _ctx.modelValue,
          "label-class": "gfu-field__label--gray",
          small: true,
          options: $props.options,
          "show-placeholder": false,
          "onUpdate:modelValue": $options.onInput
        }), null, 16 /* FULL_PROPS */, ["model-value", "options", "onUpdate:modelValue"])
      ], 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}